import moment from 'moment';

export interface SideNavProps {
    activeImage: string;
    inactive: string;
    label: string;
    keyRoute: string;
}

export const ACCOUNT_OPTIONS: string[] = ['My Profile', 'Logout'];
export const OTP_ACTIONS = {
    register: 'REGISTER',
    switch: 'SWITCH',
    stp: 'STP_REGISTRATION',
    PROSPECT_FOLIO_EMAIL: 'PROSPECT_FOLIO_EMAIL',
    PROSPECT_FOLIO_MOBILE: 'PROSPECT_FOLIO_MOBILE',
    swp: 'SWP_REGISTRATION',
    sipPause: 'SIP_PAUSE_CANCEL',
    otmCancel: 'OTM_CANCEL',
    redeem: 'REDEMPTION',
    forgot_password: 'FORGOT_PWD',
    SECURITY_ANSWER: 'SECURITY_ANSWER',
    additionalPurchase: 'ADDITIONAL_PURCHASE',
    changeEmail: 'EMAIL_CHANGE',
    changeUploadEmail: 'UPLOAD_EMAIL_CHANGE',
    changeMobile: 'MOBILE_CHANGE',
    newPurchase: 'FRESH_PURCHASE',
    login: 'LOGIN',
    otp_login: 'OTP_LOGIN',
    changeTaxStatus: 'TAX_STATUS',
    changeBank: 'BANK_ACCOUNT_TYPE_CHANGE',
    consolidationFolios: 'FOLIO_CONSOLIDATION',
    correctionFolios: 'DATA_ENTRY_ERROR',
    updateNominee: 'NOMINEE_CHANGE',
    changeDividend: 'DIV_OPTION_CHANGE',
    PRELOGIN_UPDATE_PAN: 'PRELOGIN_UPDATE_PAN',
    minorStatusChange: 'MINOR_TO_MAJOR',
    changeifsc: 'BANK_ACCOUNT_TYPE_CHANGE',
    updateMultipleBanks: 'MULTIPLE_BANK_MANDATE',
    changeBankDetails: 'BANK_ACCOUNT_DETAIL_CHANGE',
    FATCA_DECLARATION: 'FATCA_CHANGE',
    FORM_15: 'UPDATE_FORM15_G_H',
    CHANGE_PWD: 'CHANGE_PWD',
    NEW_MOBILE_ONINE_OTP: 'NEW_MOBILE_CHANGE',
    NEW_MOBILE_OFFLINE_OTP: 'UPLOAD_MOBILE_CHANGE',
    UNREGISTERED_MOBILE_CHANGE: 'UNREGISTERED_MOBILE_CHANGE',
    NEW_EMAIL_ONINE_OTP: 'NEW_EMAIL_CHANGE',
    NEW_EMAIL_OFFLINE_OTP: 'UPLOAD_EMAIL_CHANGE',
    UNREGISTERED_EMAIL_CHANGE: 'UNREGISTERED_EMAIL_CHANGE',
    CHANGE_DISPLAY_NAME: 'CHANGE_DISPLAY_NAME',
    TRANSMISSION_OF_UNITS: 'TRANSMISSION_OF_UNITS',
    VERIFY_OTP_RESET_DEVICE: 'VERIFY_OTP_RESET_DEVICE',
    RESET_DEVICE: 'RESET_DEVICE',
    FRESH_PURCHASE_MOBILE: 'FRESH_PURCHASE_MOBILE',
    FRESH_PURCHASE_EMAIL: 'FRESH_PURCHASE_EMAIL',
};

export const panRegex = /^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]{1}$/;
export const ifscRegex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
export const numberRegex = /^[0-9]*$/;

export const TaxStatusRIArray = [
    'RI',
    'INDIVIDUAL',
    'RESIDENT INDIAN',
    'MINOR',
    'ON BEHALF OF MINOR',
    '01',
    '02',
];
export const TaxStatusNRIArray = ['NRI', 'NON RESIDENT INDIAN'];

export const EQUITY = 'Equity';
export const LIQUID = 'Liquid';
export const DEBT = 'Debt';
export const OTHER = 'Other';

export const validUploadFileSize = 2e6;

export const validUploadFileFormats = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const ACCOUNT_TYPE_MASTER_DATA = ['NRE', 'NRO', 'SAVINGS'];

export const TAX_RESIDENCY_MASTER_DATA = ['RI', 'Individual', 'Minor'];

export const MODE_OF_HOLDING_MASTER_DATA = ['Anyone/Survivor', 'Single'];

export const MAX_LENGTH_FOR_PAN = 10;
export const MAX_LENGTH_FOR_NOMINEE_NAME = 60;
export const MAX_LENGTH_FOR_GUARDIAN_NAME = 120;
export const MAX_LENGTH_FOR_ADDRESS = 120;

export const oldEmailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const emailRegex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

export const mobileRegex = /^[6-9][0-9]{9}$/;
export const accountNumberRegex = /^[0-9]{9,18}$/;
export const MUTUAL_FUND_MARK_RISK_LINK =
    'https://www.etmoney.com/blog/how-to-choose-mutual-funds-for-the-short-term/';

export const FAQ_URL = '/links/faq';

export const IDCW_OPTION_PATH = '/portal/nct/change-dividend';
export const EMAIL_ADDRESS_MOBILE_NUMBER_PATH = '/portal/nct/change-mobile';
export const BANK_ACCOUNT_DETAILS_PATH = '/portal/nct/change-bank';
export const NOMINEE_DETAILS_PATH = '/portal/nct/update-nominee';
export const TAX_STATUS_PATH = '/portal/nct/change-tax';
export const MAJOR_MINOR_PATH = '/portal/nct/minor-status';
export const FORM_15_PATH = '/portal/nct/update-form15';
export const CAS_PATH = '/portal/sebi-cas';
export const UNCLAIMED_PAYOUTS_PATH = '/portal/unclaimed-payout';
export const CORRECTION_IN_ERRONEOUS_DATA_PATH = '/portal/nct/corrections-folios';
export const MULTIBANK_REGISTRATION_PATH = '/portal/nct/bank-mandate';
export const CHANGE_MOBILE_NUMBER_PATH = '/portal/nct/change-mobile';
export const CHANGE_EMAIL_PATH = '/portal/nct/change-email';
export const CHANGE_IFSC_PATH = '/portal/nct/update-ifsc';
export const SERVICE_REQUEST_PATH = '/portal/nct/actions';
export const TRANSFER_OF_UNITS = '/portal/nct/transfer-of-units';
export const CONSOLIDATION_FOLIOS_PATH = '/portal/nct/consolidation-folios';
export const TRACK_STATUS_PATH = '/portal/track';
export const FATCA_PATH = '/portal/nct/fatca-declaration';
export const SIGNUP_SIGNIN_PATH = '/investor/signin';
export const GENERAL_PATH = '/portal/portfolio';
export const REDEMPTION_PATH = `/portal/commercial/redemption`;
export const SWITCH_PATH = `/portal/commercial/switch`;

export const GENERAL = 'general';
export const SIGNUP_SIGNIN = 'signup_signin';
export const SERVICE_REQUEST = 'service_request';
export const PORTFOLIO_CAS = 'portfolio_cas';
export const BANK_ACCOUNT_DETAILS = 'bank_account_details';
export const MULTIPLE_BANK_REGISTRATION = 'multiple_bank_registration';
export const UPDATE_IFSC = 'update_ifsc';
export const IDCW_OPTION = 'idcw_option';
export const UPDATE_EMAIL = 'update_email';
export const UPDATE_MOBILE = 'update_mobile';
export const UPDATE_NOMINEE = 'update_nominee';
export const CONSOLIDATION_FOLIOS = 'consolidation_folios';
export const DATA_ERROR = 'data_error';
export const TRACK_STATUS = 'track_status';
export const UNCLAIMED_PAYOUTS = 'unclaimed_payouts';
export const FORM_15GH = 'form_15gh';
export const FATCA = 'fatca';
export const MINOR_MAJOR = 'minor_major';
export const REDEMPTION = 'redemption';
export const SWITCH = 'switch';
export const NEW_PURCHASE = 'purchase';
export const INACTIVE_FOLIOS = 'inactive_folios';

export const FaqLinks: { [key: string]: string } = {
    [IDCW_OPTION]: IDCW_OPTION_PATH,
    [UPDATE_EMAIL]: CHANGE_EMAIL_PATH,
    [UPDATE_MOBILE]: CHANGE_MOBILE_NUMBER_PATH,
    [BANK_ACCOUNT_DETAILS]: BANK_ACCOUNT_DETAILS_PATH,
    [UPDATE_NOMINEE]: NOMINEE_DETAILS_PATH,
    // [TAX_STATUS]: TAX_STATUS_PATH,
    [UNCLAIMED_PAYOUTS]: UNCLAIMED_PAYOUTS_PATH,
    [FORM_15GH]: FORM_15_PATH,
    [PORTFOLIO_CAS]: CAS_PATH,
    [DATA_ERROR]: CORRECTION_IN_ERRONEOUS_DATA_PATH,
    [MINOR_MAJOR]: MAJOR_MINOR_PATH,
    [MULTIPLE_BANK_REGISTRATION]: MULTIBANK_REGISTRATION_PATH,
    [UPDATE_IFSC]: CHANGE_IFSC_PATH,
    [SERVICE_REQUEST]: SERVICE_REQUEST_PATH,
    [CONSOLIDATION_FOLIOS]: CONSOLIDATION_FOLIOS_PATH,
    [TRACK_STATUS]: TRACK_STATUS_PATH,
    [FATCA]: FATCA_PATH,
    [SIGNUP_SIGNIN]: SIGNUP_SIGNIN_PATH,
    [GENERAL]: GENERAL_PATH,
    [REDEMPTION]: REDEMPTION_PATH,
    [SWITCH]: SWITCH_PATH,
};

export const TRANSACTION_RESOURCE_TYPES = ['SoA Holdings', 'Demat Holdings'];
export const TRACK_STATUS_TYPES = ['Service Requests', 'Commercial Transactions'];

export const ALL_HOLDINGS = 'allHoldings';
export const ZERO_HOLDINGS = 'zeroHoldings';
export const NON_ZERO_HOLDINGS = 'nonZeroHoldings';

export const THRESH_HOLD_MKT_VALUE = 1000000;
export const HOME_PATH = '/portal/home';
export const REGISTER_WITH_EMAIL = 'EMAIL';
export const REGISTER_WITH_MOBILE = 'MOBILE';
export const DEFAULT_MAX_INVESTMENT = 10000000; // 1cr
export const DEFAULT_MIN_TAT = 7;
export const MaxAccountNumberLength = 19;

export const OTM_MAX_DATE = (startDate: string | Date) => {
    const currentDate = new Date(startDate);
    return new Date(currentDate.setFullYear(currentDate.getFullYear() + 40));
};

export const MAX_DATE = new Date(2099, 11, 31);

export const isMobileDevice = () => {
    const _window: any = window;
    return !!_window.cordova;
};

export const isNumber = (value: any) => {
    if (/^\d+$/.test(value) || !value) {
        return true;
    }
    return false;
};

export const isFloatingNumber = (value: any) => {
    if (value === '.') return false;
    const floatReg = new RegExp('^[+]?([0-9]{0,})*[.]?([0-9]{0,3})?$', 'g');
    if (floatReg.test(value) || !value) {
        return true;
    }
    return false;
};

export const addDialCode = (mobile: string = '') => {
    if (!mobile) {
        return mobile;
    }
    if (mobile.length === 13) return mobile;
    return `+91${mobile.slice(mobile.length - 10)}`;
};

export const getBankAddress = (
    address1: string | null,
    address2: string | null,
    address3: string | null,
) => {
    if (address1) {
        return address1;
    } else if (address2) {
        return address2;
    } else if (address3) {
        return address3;
    }
};

export const getDate = (value: string) => {
    if (!value) return value;
    return new Date(value);
};

export const getKfinFormatDate = (date: string) => {
    const parsedDate = moment(date, 'DD-MMM-YYYY');
    return parsedDate.format('DD/MM/YYYY');
};

export const getDateString = (value: string | Date) => {
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
        d.setFullYear(Math.abs(d.getFullYear()));
        return moment(d).format('DD-MMM-YYYY');
    } else {
        if (!value) return '';
        const today = moment(value);
        return today.format('DD-MMM-YYYY');
    }
    // return '';
};

export const validateIfsc = (ifsc: string) => {
    if (!ifsc) return true;
    if (/^[A-Za-z0-9]+$/.test(ifsc) && ifsc.length < 12) {
        return true;
    }
    return false;
};

export const minDateForCalender = () => {
    const currentYear = new Date().getFullYear();
    const day = new Date().getDay();
    const month = new Date().getMonth();
    return moment(new Date(`${currentYear - 100}-${month + 1}-${day}`)).format('YYYY-MM-DD');
};

export const _minDateForCalender = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 100);
    return date;
};

export const accountNumberValidation = (value: string) => {
    if ((/^\d+$/.test(value) || !value) && value.length < MaxAccountNumberLength) {
        return true;
    }
    return false;
};

export const checkForOnlyAlphabets = (value: string) => {
    if (/^[A-Za-z ]+$/.test(value) || !value) {
        return true;
    }
    return false;
};

export const isAlphaNumeric = (value: string) => {
    if (/^[A-Za-z0-9 ]+$/.test(value) || !value) {
        return true;
    }
    return false;
};

export const CommercialRootPath = '/portal/commercial';
